module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_5010.d43c1aef.png";